'use client';

import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { PostFinalCtaStoryblok } from '@/storyblok/types';
import { generateServiceLocationUrl } from '@/routes';
import { monaFont } from '@/styles/fonts';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { ArrowRightIcon, ClockIcon, ShieldCheckIcon, WalletIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';
import { useRouter } from 'next/navigation';

export const PostFinalCTA: StoryblokReactComponent<PostFinalCtaStoryblok> = ({ component }) => {
  const router = useRouter();

  return (
    <div className="rounded-2xl border bg-white px-5 py-8 text-center shadow-card sm:px-6 sm:py-10 md:px-12 md:py-12">
      <span className={clsx(monaFont, 'mb-3 block text-sm font-medium uppercase tracking-widest text-brandGreen-500 md:mb-4 lg:text-base')}>
        {component.subtitle}
      </span>
      <h2 className="text-2xl !font-bold leading-tight tracking-tight text-primary lg:text-4xl">{component.title}</h2>
      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-relaxed text-neutral-lighter lg:text-lg">{component.description}</p>

      <div className="mt-6 md:mt-7">
        <ELButton
          label="Prenota una visita"
          variant="floating"
          color="secondary"
          trailingIcon={<ArrowRightIcon className="size-4 stroke-2" />}
          size="small"
          className="text-primary-white h-12 w-full shrink-0 rounded-full bg-secondary px-6 text-white transition-all hover:bg-secondary-hover sm:w-auto lg:h-14 lg:px-9 [&>div]:gap-2 [&_span]:text-base [&_span]:font-semibold"
          onClick={() => router.push(generateServiceLocationUrl('treatment', { service: component.speciality }))}
        />
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-center gap-2 md:mt-7">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brandBlue-100 px-2.5 py-1 text-xs font-medium text-brandBlue-500">
          <ShieldCheckIcon className="size-4 shrink-0 stroke-2" />
          <span>Specialisti verificati</span>
        </span>

        <span className="inline-flex items-center gap-1.5 rounded-full bg-brandBlue-100 px-2.5 py-1 text-xs font-medium text-brandBlue-500">
          <ClockIcon className="size-4 shrink-0 stroke-2" />
          <span>Disponibilità rapide</span>
        </span>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brandBlue-100 px-2.5 py-1 text-xs font-medium text-brandBlue-500">
          <WalletIcon className="size-4 shrink-0 stroke-2" />
          <span>Prezzi trasparenti</span>
        </span>
      </div>
    </div>
  );
};
